import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export async function deleteLeadsWindow(id: number): Promise<void> {
  return axios.delete(`${API_URL}/api/crm/leads-windows/${id}/`);
}
